@if (quotation.id_factura) {
  <div class="notes-detail__header">
    <h2 class="notes-detail__title">
      {{ 'global.notes.detail-modal-title' | translate }}
      @if (invoiceConsecutiveNumber) {
        {{ invoiceConsecutiveNumber }}
      }
    </h2>
    @if (dianInvoiceNumber) {
      <p class="notes-detail__dian">{{ dianInvoiceNumber }}</p>
    }
    @if (customerDisplayName) {
      <p class="notes-detail__customer">{{ customerDisplayName }}</p>
    }
  </div>
}

<div class="notes-detail__summary">
  <div class="notes-detail__summary-tile notes-detail__summary-tile--plain">
    <span class="notes-detail__summary-label">{{
      'global.notes.detail-original-total' | translate
    }}</span>
    <span class="notes-detail__summary-value">{{
      originalTotal | number: '1.0-0'
    }}</span>
  </div>
  <div class="notes-detail__summary-tile">
    <span class="notes-detail__summary-label">{{
      'global.notes.detail-adjustment' | translate
    }}</span>
    <span
      class="notes-detail__summary-value notes-detail__summary-value--warning"
    >
      @if (netAdjustment > 0) {
        +
      }
      {{ netAdjustment | number: '1.0-0' }}</span
    >
  </div>
  <div class="notes-detail__summary-tile">
    <span class="notes-detail__summary-label">{{
      'global.notes.detail-adjusted-total' | translate
    }}</span>
    <span class="notes-detail__summary-value">{{
      adjustedTotal | number: '1.0-0'
    }}</span>
  </div>
  <div class="notes-detail__summary-tile">
    <span class="notes-detail__summary-label">{{
      'global.notes.detail-outstanding-balance' | translate
    }}</span>
    <span
      class="notes-detail__summary-value"
      [class.notes-detail__summary-value--warning]="hasOutstandingBalance"
      >{{ outstandingBalance | number: '1.0-0' }}</span
    >
  </div>
</div>

<div class="notes-detail__table-wrapper">
  <table class="notes-detail__table">
    <thead>
      <tr>
        <th>{{ 'global.notes.detail-column-type' | translate }}</th>
        <th>{{ 'global.notes.detail-column-number' | translate }}</th>
        <th>{{ 'global.notes.detail-column-concept' | translate }}</th>
        <th class="notes-detail__col--value">
          {{ 'global.notes.detail-column-value' | translate }}
        </th>
        <th>{{ 'global.notes.detail-column-date' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track row.note.id_nota) {
        <tr
          class="notes-detail__row"
          [class.notes-detail__row--credit]="row.isCredit"
        >
          <td>
            <span
              class="notes-detail__badge"
              [class.notes-detail__badge--credit]="row.isCredit"
              [class.notes-detail__badge--debit]="!row.isCredit"
            >
              {{ row.isCredit ? 'NC' : 'ND' }}
            </span>
          </td>
          <td class="notes-detail__col--muted">{{ row.number }}</td>
          <td>{{ row.note.concepto }}</td>
          <td
            class="notes-detail__col--value"
            [class.notes-detail__amount--credit]="row.isCredit"
            [class.notes-detail__amount--debit]="!row.isCredit"
          >
            @if (!row.isCredit) {
              +
            }
            {{ row.signedTotal | number: '1.0-0' }}
          </td>
          <td class="notes-detail__col--muted">
            {{ row.note.createAt || row.note.dueDate | date: 'dd/MM/yy' }}
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="5" class="notes-detail__empty">
            {{ 'global.notes.detail-empty' | translate }}
          </td>
        </tr>
      }
    </tbody>
    @if (rows.length > 0) {
      <tfoot>
        <tr>
          <td colspan="5">
            <div class="notes-detail__totals-row">
              <span class="notes-detail__totals-group">
                <span class="notes-detail__totals-label"
                  >{{ 'global.notes.detail-total-credit' | translate }}:</span
                >
                <span
                  class="notes-detail__totals-value notes-detail__amount--credit"
                  >{{ -creditTotal | number: '1.0-0' }}</span
                >
              </span>
              <span class="notes-detail__totals-group">
                <span class="notes-detail__totals-label"
                  >{{ 'global.notes.detail-total-debit' | translate }}:</span
                >
                <span
                  class="notes-detail__totals-value notes-detail__amount--debit"
                  >+{{ debitTotal | number: '1.0-0' }}</span
                >
              </span>
              <span
                class="notes-detail__totals-group notes-detail__totals-group--net"
              >
                <span class="notes-detail__totals-label--net"
                  >{{ 'global.notes.detail-net' | translate }}:</span
                >
                <span class="notes-detail__totals-value notes-detail__net">
                  @if (netAdjustment > 0) {
                    +
                  }
                  {{ netAdjustment | number: '1.0-0' }}</span
                >
              </span>
            </div>
          </td>
        </tr>
      </tfoot>
    }
  </table>
</div>

<div class="notes-detail__actions">
  <v-one-button
    [text]="'global.payments.close' | translate"
    variant="primary"
    (buttonClick)="handleCloseButtonClick()"
  />
</div>
